import { render, staticRenderFns } from "./FormSopimusLaskutusjaksoMuokkaa.vue?vue&type=template&id=3827715a&scoped=true&"
import script from "./FormSopimusLaskutusjaksoMuokkaa.vue?vue&type=script&lang=js&"
export * from "./FormSopimusLaskutusjaksoMuokkaa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3827715a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDatePicker,VForm,VMenu,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3827715a')) {
      api.createRecord('3827715a', component.options)
    } else {
      api.reload('3827715a', component.options)
    }
    module.hot.accept("./FormSopimusLaskutusjaksoMuokkaa.vue?vue&type=template&id=3827715a&scoped=true&", function () {
      api.rerender('3827715a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormSopimusLaskutusjaksoMuokkaa.vue"
export default component.exports